<template>
	<div class="sidebar">
		<!-- 边栏导航 -->
		<el-menu
			class="el-menu-vertical-demo sidebar-list"
			unique-opened
			:default-active="$store.state.activeMenu"
			:collapse="$store.state.isCollapse"
		>
			<template v-for="(item) in menuList">
				<template v-if="!item.secondMenus">
					<el-menu-item :index="item.activeMenu" :key="item.activeMenu" :class="( $store.state.activeMenu == item.activeMenu ? 'active' : '' )">
						<div class="link" @click="onClickMenu(item)">
							<img
								_m="l-20px r-4px"
								:src="require(`@/assets/icons/images/${item.icon}-active.png`)"
								width="20px"
								v-if="$store.state.activeMenu == item.activeMenu && item.icon"
							/>
							<img _m="l-20px r-4px" :src="require(`@/assets/icons/images/${item.icon}.png`)" width="20px" v-else-if="item.icon" />
							<span slot="title" >{{ item.name }}</span>
						</div>
					</el-menu-item>
				</template>
				<template v-else>
          <template v-if="!item?.secondMenus[0]?.secondMenus">
            <el-submenu :index="item.activeMenu" :key="item.activeMenu" ref="el-submenu" >
              <template slot="title">
                <img
                  _m="l-20px r-4px"
                  :src="require(`@/assets/icons/images/${item.icon}-active.png`)"
                  width="20px"
                  v-if="$store.state.activeMenu?.split('-')[0] == item.activeMenu?.split('-')[0] && item.icon"
                />
                <img _m="l-20px r-4px" :src="require(`@/assets/icons/images/${item.icon}.png`)" width="20px" v-else-if="item.icon" />
                <span :style="{ color: $store.state.activeMenu?.split('-')[0] == item.activeMenu?.split('-')[0] ? '#ff5e2a' : '' }">{{ item.name }}</span>
                <svg class="icon el-submenu__icon-arrow" aria-hidden="true" :style="{ color: $store.state.activeMenu?.split('-')[0] == item.activeMenu?.split('-')[0] ? '#ff5e2a' : '' }">
                  <use xlink:href="#icon-iconfilldownarrow"></use>
                </svg>
              </template>
              <template v-for="(item2) in item.secondMenus">
                <el-menu-item
                  :class="`second-menus ${$store.state.activeMenu?.split('-')[0] == item2.activeMenu?.split('-')[0] && $store.state.activeMenu?.split('-')[1] == item2.activeMenu?.split('-')[1] ? 'active' : ''}`"
                  :index="item2.activeMenu"
                  :key="item2.activeMenu"
                  @click="onClickMenu(item2)"
                >
                  <span>{{ item2.title }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
          <!-- 不能怪我，以前就是这样的，我只能按旧的逻辑走下去更快实现 -->
          <template v-else>
            <el-submenu popper-class="popper-class" :index="item.activeMenu" :key="item.activeMenu" ref="el-submenu">
              <template slot="title">
                <img
                  _m="l-20px r-4px"
                  :src="require(`@/assets/icons/images/${item.icon}-active.png`)"
                  width="20px"
                  v-if="$store.state.activeMenu?.split('-')[0] == item.activeMenu?.split('-')[0] && item.icon"
                />
                <img _m="l-20px r-4px" :src="require(`@/assets/icons/images/${item.icon}.png`)" width="20px" v-else-if="item.icon" />
                <span :style="{ color: $store.state.activeMenu?.split('-')[0] == item.activeMenu?.split('-')[0] ? '#ff5e2a' : '' }">{{ item.name }}</span>
                <svg class="icon el-submenu__icon-arrow" aria-hidden="true" :style="{ color: $store.state.activeMenu?.split('-')[0] == item.activeMenu?.split('-')[0] ? '#ff5e2a' : '' }">
                  <use xlink:href="#icon-iconfilldownarrow"></use>
                </svg>
              </template>
              <template v-for="(item2) in item.secondMenus">
                <el-submenu
                  :class="`second-menus ${$store.state.activeMenu?.split('-')[0] == item2.activeMenu?.split('-')[0] && $store.state.activeMenu?.split('-')[1] == item2.activeMenu?.split('-')[1] ? 'active' : ''}`"
                  :index="item2.activeMenu"
                  :key="item2.activeMenu"
                  @click="onClickMenu(item2)"
                >
                  <template slot="title">
                    <img
                      _m="l-20px r-4px"
                      :src="require(`@/assets/icons/images/${item2.icon}-active.png`)"
                      width="20px"
                      v-if="$store.state.activeMenu?.split('-')[0] == item2.activeMenu?.split('-')[0] && $store.state.activeMenu?.split('-')[1] == item2.activeMenu?.split('-')[1] && item2.icon"
                    />
                    <img _m="l-20px r-4px" :src="require(`@/assets/icons/images/${item2.icon}.png`)" width="20px" v-else-if="item2.icon" />
                    <span :style="{ color: $store.state.activeMenu?.split('-')[0] == item2.activeMenu?.split('-')[0] && $store.state.activeMenu?.split('-')[1] == item2.activeMenu?.split('-')[1] ? '#ff5e2a' : '' }">{{ item2.title }}</span>
                    <svg class="icon el-submenu__icon-arrow" aria-hidden="true" :style="{ color: $store.state.activeMenu?.split('-')[0] == item2.activeMenu?.split('-')[0] && $store.state.activeMenu?.split('-')[1] == item2.activeMenu?.split('-')[1] ? '#ff5e2a' : '' }">
                      <use xlink:href="#icon-iconfilldownarrow"></use>
                    </svg>
                  </template>
                  <template v-for="(item3) in item2.secondMenus">
                    <el-menu-item
                      :class="`second-menus ${$store.state.activeMenu == item3.activeMenu ? 'active' : ''}`"
                      :index="item3.activeMenu"
                      :key="item3.activeMenu"
                      @click="onClickMenu(item3)"
                    >
                      <span>&ensp;&ensp;{{ item3.title }}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
				</template>
			</template>
		</el-menu>
	</div>
</template>

<script>
export default {
	props: {
		menuList: {
			type: Array,
			default() {
				return []
			}
		}
	},
	data() {
		return {
			subject_id: null,
			testSummary: null,
		}
	},
	computed: {
		userInfo() {
			return this.$store.state.user.userInfo || {}
		},
		sidebarTestBadge() {
			if (!this.testSummary) return null

			if (this.testSummary.badge_info.exam > 0) {
				return '考'
			}

			if (this.testSummary.badge_info.daily_test > 0) {
				return '测'
			}

			return null
		},

		accountLabels() {
			switch (this.$store.state.user.userInfo.type) {
				case this.$api.account.types.STUDENT.value:
					return [this.userInfo.student.class_grade.class_name, this.userInfo.student.school.name]
				case this.$api.account.types.TEACHER.value:
					if (this.userInfo.teacher == null) {
						return ['未绑定学校', '']
					} else {
						return [
							this.userInfo.teacher.school.name,
							this.userInfo.teacher.subject.name + (this.userInfo.teacher.is_supervisor ? '学科长' : '教师')
						]
					}

				case this.$api.account.types.SCHOOL_ADMIN.value:
					if (this.userInfo.school_admin == null) {
						return ['未绑定学校', '']
					} else {
						return [this.userInfo.school_admin.school.name, '学校管理']
					}
				case this.$api.account.types.PLATFORM_ADMIN.value:
					if (this.userInfo.platform_admin == null) {
						return ['系统平台管理']
					} else {
						return [this.userInfo.realname + '系统平台管理']
					}
			}
			return []
		}
	},
	async created() {
		// 获取 subject_id
		this.initSubjectId()
	},
  watch: {
    menuList: {
      handler(val) {
        try {
          const { meta, params } = this.$route
          const resultNode = this.findNodeByTo(val, meta.entry_menu);
          if (resultNode?.secondMenus && resultNode?.secondMenus?.length > 0) {
            let obj = resultNode.secondMenus.find(item => item.sbid == params?.sbid)
            this.$store.state.activeMenu = obj.activeMenu
          } else {
            this.$store.state.activeMenu = resultNode.activeMenu
          }
        } catch(err) {
          console.log('-')
        }
      },
      immediate: true,
      deep: true
    },
    $route: {
      handler(val) {
        try {
          const { meta, params } = this.$route
          const resultNode = this.findNodeByTo(this.menuList, meta.entry_menu);
          if (resultNode?.secondMenus && resultNode?.secondMenus?.length > 0) {
            let obj = resultNode.secondMenus.find(item => item?.sbid == params?.sbid)
            this.$store.state.activeMenu = obj.activeMenu
          } else {
            this.$store.state.activeMenu = resultNode.activeMenu
          }
        } catch(err) {
          console.log('-')
        }
      },
      deep: true
    }
  },
	methods: {
    findNodeByTo(tree, targetTo) {
      for (const node of tree) {
        if (node.to == targetTo) {
          return node;
        }
        if (node.secondMenus && node.secondMenus.length > 0) {
          const foundInChildren = this.findNodeByTo(node.secondMenus, targetTo);
          if (foundInChildren) {
            return foundInChildren;
          }
        }
      }
      return null;
    },
		initSubjectId() {
			const type = this.$store.state.user.userInfo.type

			if (type === this.$api.account.types.TEACHER.value) {
				this.subject_id = this.$store.state.user.userInfo.teachers.subject_id
			}

			if (
				type === this.$api.account.types.BUREAU_ADMIN.value &&
				this.$store.state.user.userInfo.bureau_admin.subject_id != 0
			) {
				this.subject_id = this.$store.state.user.userInfo.bureau_admin.subject_id
			}
		},
		getQuery(query) {
			if (typeof query === 'object') {
				return query
			}
			if (typeof query === 'function') {
				return query()
			}
		},
		isActiveMenu(item) {
      // return this.$store.state.activeMenu == item.activeMenu
			// if (item.contextedTo) {
			// 	// 有context，比较context以及entry_menu
      //   console.log(this.$route.meta.entry_menu, item)
			// 	if (this.$route.meta.entry_menu == item.contextedTo.target && this.$route.params.sbid == item.sbid) {
      //     // if (idx2 != undefined) {
      //     //   if (idx3 != undefined) {
      //     //     // this.$store.state.activeMenu = idx + '-' + idx2 + '-' + idx3
      //     //     this.$store.state.activeMenu = idx + '-' + idx2
      //     //   } else {
      //     //     this.$store.state.activeMenu = idx + '-' + idx2
      //     //   }
      //     // } else {
      //     //   this.$store.state.activeMenu = idx.toString()
      //     // }
			// 		return true
			// 	} else {
			// 		return false
			// 	}
			// } else {
      //   console.log(this.$route.meta.entry_menu, item)
			// 	if (this.$route.meta.entry_menu == item.to) {
      //     // if (idx2 != undefined) {
      //     //   if (idx3 != undefined) {
      //     //     // this.$store.state.activeMenu = idx + '-' + idx2 + '-' + idx3
      //     //     this.$store.state.activeMenu = idx + '-' + idx2 + '-'
      //     //   } else {
      //     //     this.$store.state.activeMenu = idx + '-' + idx2
      //     //   }
      //     // } else {
      //     //   this.$store.state.activeMenu = idx.toString()
      //     // }
			// 		return true
			// 	} else {
			// 		return false
			// 	}
			// }
		},
		onClickMenu(item) {
      this.$store.state.activeMenu = item.activeMenu

			if (item.contextedTo) {
				this.$route.meta.context = item.contextedTo.context
			}

			// jump
			if (item.to != this.$route.name) {
				//跳转目标为工作台特殊处理
				if (item.to === 'workbenchMain') {
					this.$router.push({ path: '/workbench' })
					return
				}

				this.$router.push({
					name: item.to,
					query: this.getQuery(item.query),
					params: { sbid: item.sbid ?? this.subject_id }
				})
			} else {
				//学生测试侧边栏
				if (item.sbid && item.sbid != this.$route.params.sbid) {
					//防止重复点击报错
					this.$router.push({
						name: item.to,
						query: this.getQuery(item.query),
						params: { sbid: item.sbid }
					})
				}
			}
		}
	}
}
</script>
<style lang="scss">
.sidebar {
	display: inline-block;
  overflow-y: auto;
	position: sticky;
	top: 56px;
	// width: 190px;
	background: #ffffff;
	// min-height: 862px;
	//border-radius: 8px;
	box-sizing: border-box;
	//border: 1px solid #ebeef5;
	//padding-bottom: 25px;
	height: calc(100vh - 60px);
	.el-menu {
		border: none;
	}

	.userinfo {
		text-align: center;
		padding: 25px 0 25px;
		.avatar {
			display: inline-flex;
			overflow: hidden;
			width: 70px;
			height: 70px;
			border-radius: 50%;
			border: 1px solid #f0f0f0;
			margin-bottom: 25px;
			img {
				object-fit: cover;
				width: 100%;
			}
		}
		dl {
			margin: 0;
			dt {
				font-size: 14px;
				color: #333033;
				line-height: 20px;
				width: 98px;
				margin: 0 auto;
				margin-bottom: 10px;

				.icon {
					margin-left: 4px;
					font-size: 12px;
					color: #999999;
				}
			}
			dd {
				font-size: 12px;
				font-weight: 400;
				color: #999999;
				line-height: 17px;
				margin-bottom: 5px;
				width: 98px;
				margin: 0 auto;
			}
		}
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 190px;
	}

	ul.sidebar-list {
		list-style-type: none;
		padding: 0;
		margin: 0;
		margin-top: 1px;
	}

	.sidebar-list {
		li {
			color: #2213f5;
			cursor: pointer;
			padding: 0 !important;

			.sidebar-badge .el-badge__content {
				margin-top: 0px !important;
				margin-right: -8px !important;
				border: 0px !important;
			}

			.icon {
				margin-left: 20px;
				margin-right: 4px;
				opacity: 0.8;
			}
			.link {
				font-weight: bold;
				display: flex;
				align-items: center;
				flex: 1;
				height: 100%;
				font-size: 14px;
				transition: background-color 0.3s;
			}
			&:hover {
				position: relative;
				.link {
					background: rgba($color: #ff5e2a, $alpha: 0.1);
				}
			}

			&.active {
				color: #ff5e2a;
				.link {
					background: rgba($color: #ffffff, $alpha: 1);
					.icon {
						opacity: 1;
					}
				}
			}

      // &.el-submenu.is-active {
      //   .el-submenu__title {
      //     background: #ffffff;
      //     color: #ff5e2a;
      //   }
      //   .icon.el-submenu__icon-arrow {
      //     opacity: 0.5;
      //   }
      // }
      // &.el-submenu.is-active.is-opened {
      //   .el-submenu__title {
      //     background: transparent;
      //     color: #ff5e2a;
      //   }
      // }
			svg {
				font-size: 19px;
			}
		}
		.el-menu-item,
		.el-submenu__title {
			transition: background 0.3s;
			height: 45px;
			line-height: 45px;
			padding: 0 !important;
			color: #8d8d8d;

			i {
				margin-top: -5px;
				color: #ff5e2a;
			}
		}

		.el-submenu__title {
			font-weight: bold;
			i.el-submenu__icon-arrow {
				display: none;
			}
			.icon.el-submenu__icon-arrow {
				opacity: 0.2;
				right: 8px;
				font-size: 12px;
				margin-top: -6px;
			}
		}
		.el-menu-item:hover {
			background-color: transparent;
		}

		.second-menus {
			min-width: auto;
			background: #ffffff;
			span {
				margin-left: 40px;
			}
			&.active {
				background: #fafafa !important;
			}
			&:hover {
				background: rgba($color: #ff5e2a, $alpha: 0.1);
			}
		}
	}
}
</style>
